module.exports = __webpack_public_path__ + "img/by.8a8e48c5.svg";